import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Clean Native Smooth Scroll Engine
 * Ensures 60fps native momentum scrolling on all devices (trackpads, mice, touch)
 * without janky wheel event hijacking.
 */
export function initSmoothScroll() {
  // Update GSAP ScrollTrigger on window scroll
  window.addEventListener('scroll', () => {
    ScrollTrigger.update();
  }, { passive: true });
}
